var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { value: _vm.dialog, "max-width": "500px" },
          on: {
            "click:outside": function ($event) {
              return _vm.$emit("updateDialog", false)
            },
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.createItem.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.modal_title)),
                    ]),
                  ]),
                  _c("v-card-text", [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              "data-vv-as": "nombre",
                              label: "Nombre*",
                              name: "name",
                              disabled: _vm.isViewModal(),
                            },
                            model: {
                              value: _vm.item.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                          _c("span", { staticClass: "red--text" }, [
                            _vm._v(_vm._s(_vm.errors.first("name"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-12 mt-3" },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "offset-y": "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              style: { color: _vm.item.color },
                                              attrs: {
                                                label: "Color",
                                                readonly: "",
                                                disabled: _vm.isViewModal(),
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "prepend-inner",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            style: {
                                                              color:
                                                                _vm.item.color,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-palette"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.item.color,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "color",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.color",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.colorPickerMenu,
                                callback: function ($$v) {
                                  _vm.colorPickerMenu = $$v
                                },
                                expression: "colorPickerMenu",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-color-picker", {
                                    attrs: {
                                      "hide-canvas": "",
                                      "hide-inputs": "",
                                      "show-swatches": "",
                                      "swatches-max-height": "150",
                                      mode: "hexa",
                                    },
                                    model: {
                                      value: _vm.item.color,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "color", $$v)
                                      },
                                      expression: "item.color",
                                    },
                                  }),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.colorPickerMenu = false
                                            },
                                          },
                                        },
                                        [_vm._v("Cerrar")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateDialog", false)
                            },
                          },
                        },
                        [_vm._v("Cerrar")]
                      ),
                      !_vm.isViewModal()
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                text: "",
                                type: "submit",
                                loading: _vm.loading,
                              },
                            },
                            [_vm._v(_vm._s(_vm.formBtn))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }